import React from "react";
import HeroSection from "../../components/HeroSection/HeroSection";
import hero_image_4 from "../../assets/images/hero_image_4.jpg";
import section_image_5 from "../../assets/images/section_image_5.jpg";
import section_image_6 from "../../assets/images/section_image_6.jpg";
import section_image_7 from "../../assets/images/section_image_7.jpg";
import "./InHouseExpertise.css";
import Heading from "../../components/Heading/Heading";
import RightImage from "../../components/RightSection/RightImage";
import LeftImage from "../../components/LeftSection/LeftImage";
import { Helmet } from "react-helmet";

export default function InHouseExpertise() {
  return (
    <div className="inhouse_page">
      <Helmet>
        <title>In-House Expertise | Elegro Energy Limited</title>
        <link rel="canonical" href="/inhouseexpertise" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="A highly successful and experienced trading and construction company, with the best in-house expertise."
        />
      </Helmet>
      <HeroSection
        heroTitle="OUR IN-HOUSE EXPERTISE"
        heroParagraph="A highly successful and experienced trading and construction company."
        btnLink="/projects"
        btnText="View Projects"
        heroImage={hero_image_4}
      />
      <div className="list_of_inhouse container padding_top_bottom">
        <Heading MainHeader="OUR IN-HOUSE EXPERTISE" />
        <RightImage
          Subtitle="Finance"
          Paragraph="Financial experience and expertise. Smooth processing of all lines of deferred payments such as Letters of Credit, Standby Guarantees, Bid Bonds and Performance Bonds"
          btnLink=""
          btnText=""
          SideImage={section_image_5}
        />
        <LeftImage
          Subtitle="Logistic and Packing"
          Paragraph="Ensure correct packaging methods (according to world standards) are used to protect products. Direct control of shipping lines and road haulers using our in-house logistics department."
          btnLink=""
          btnText=""
          SideImage={section_image_6}
        />
        <RightImage
          Subtitle="Contract Management"
          Paragraph="Ensure that the project runs according to the contract parameters Monitoring deliveries to the customer"
          btnLink=""
          btnText=""
          SideImage={section_image_7}
        />
        <LeftImage
          Subtitle="Production"
          Paragraph="Ensure that the production time of the products coincides with the contract time frame We do not represent specific manufacturers allowing us to source the best solution for each individual client requirement Factory testing and external testing of products using world class laboratories such as KEMA."
          btnLink=""
          btnText=""
          SideImage={section_image_5}
        />
        <RightImage
          Subtitle="Finance"
          Paragraph="Sourcing global manufacturers with factories and products that comply to Internationally recognised Standards such as ISO9001. Sourcing of products of the highest quality at reasonable prices. Ability to provide a wide range of electrical and other products."
          btnLink=""
          btnText=""
          SideImage={section_image_6}
        />
        <LeftImage
          Subtitle="Training"
          Paragraph="We have successfully trained personnel in several different fields across Africa."
          btnLink=""
          btnText=""
          SideImage={section_image_7}
        />
      </div>
    </div>
  );
}
